/* 免登录白名单 path或者title */
export const routeWhites = [
    '/login',// 登录页
    '/reg',// 注册
    '/password/username',// 找回密码
    '/password/new',// 找回密码-新密码
];

// 强制修改密码或绑定code与跳转路由映射
export const passportCodeMap = new Map([
    ['601', '/password'],// 初始化密码为临时密码，请立即修改密码！
    ['602', '/password'],// 您的密码长时间未修改，为了安全起见，请立即修改密码！
    ['603', '/bind'],// 手机号或邮箱未完善
])